import Link from "next/link";
import { useTranslation, Trans } from "next-i18next";
import '../styles/_home-tab-blog.module.scss';

const BlogHomeTab = ({ postData }) => {
    const { t } = useTranslation("home");
    let posts = postData.posts.edges
    return <>
        <section className={'home_tab_blog'}>
            <div className={'container'}>

                <div className="d-flex">
                    <div className="left-block">
                        <h2>
                            <Trans
                                ns="home"
                                i18nKey="handpicked.title"
                                components={{
                                    highlight: <span className="text-gradient" />,
                                }}
                            />
                        </h2>
                    </div>
                    <div className="right-block">
                        {(posts.length > 0 ? posts.slice(0, 3).map((__data: any, index: string) => {
                            let data = __data.node
                            return <Link prefetch={false} href={`/blog${data.uri}`}><div className={'in-card'} key={index}>
                                <div className={"category-parrent d-flex"} ><div className="in-flex"><div className={`category ${data?.categories?.nodes[0].slug}`}>{data?.categories?.nodes[0].name}</div> <div className={`category read-time`}>{data?.seo?.readingTime} mins read</div></div> <p className="author-name">{data?.author?.node?.name}</p></div>
                                <p>{data.title}</p>
                            </div></Link>
                        }) : <h4>{t('blogHome.cta.comingSoon')}</h4>)}
                    </div>
                </div>

            </div>
        </section>
    </>
}


export default BlogHomeTab;